import themeHelpers from "@gotamedia/fluffy/utils/theme/helpers";
import styled, { css } from "styled-components";
const AdPortalWrapper = styled.div.withConfig({
  displayName: "style__AdPortalWrapper",
  componentId: "sc-571git-0"
})(["width:100%;min-height:100vh;display:flex;flex-direction:column;"]);
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-571git-1"
})(["", ""], themeHelpers.isNotSmallDevice(css(["position:relative;"])));
const HeaderContainer = styled.div.withConfig({
  displayName: "style__HeaderContainer",
  componentId: "sc-571git-2"
})(["display:flex;padding:12px 0px 12px 32px;margin:0 auto;max-width:1600px;width:100%;", " @media screen and (max-width:1300px){padding:12px 16px;}"], themeHelpers.isNotLargeDevice(css(["padding:12px 16px;"])));
const BrandColorBanner = styled.div.withConfig({
  displayName: "style__BrandColorBanner",
  componentId: "sc-571git-3"
})(["height:4px;align-self:stretch;background:", ";"], ({
  color
}) => color);
const HeaderBanner = styled.div.withConfig({
  displayName: "style__HeaderBanner",
  componentId: "sc-571git-4"
})(["height:1px;align-self:stretch;background:var(--general-grey-4-dadad-8,#DADAD8);"]);
const HeaderWrapper = styled.div.withConfig({
  displayName: "style__HeaderWrapper",
  componentId: "sc-571git-5"
})([""]);
const ContentWrapper = styled.div.withConfig({
  displayName: "style__ContentWrapper",
  componentId: "sc-571git-6"
})(["margin:0 auto;max-width:1600px;"]);
const FooterWrapper = styled.div.withConfig({
  displayName: "style__FooterWrapper",
  componentId: "sc-571git-7"
})(["margin:0 auto;max-width:1600px;"]);
export { HeaderContainer, AdPortalWrapper, ContentWrapper, FooterWrapper, BrandColorBanner, HeaderWrapper, HeaderBanner, Wrapper };